/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationEmployeesAliases {
  AVATAR_DOCTOR = 'avatar-doctor',
  DECK_1 = 'deck-1',
  FETCH_EMPLOYEE = 'fetch-employee',
  FETCH_LIST_EMPLOYEES = 'fetch-list-employees',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FETCH_TYPE_OF_LINK = 'fetch-type-of-link',
  FIELD_0 = 'field-0',
  FIELD_AVATAR = 'field-avatar',
  FIELD_EMAIL = 'field-email',
  FIELD_EMAILL = 'field-emaill',
  FIELD_FILTER = 'field-filter',
  FIELD_NAME = 'field-name',
  FIELD_NR_SEQUENCE = 'field-nrSequence',
  FIELD_PHONEE = 'field-phonee',
  FIELD_TAXPAYER_ID = 'field-taxpayer-id',
  FIELD_TELEPHONE = 'field-telephone',
  FIELD_TYPE_LINK = 'field-type-link',
  FIELD_TYPE_OF_LINK = 'field-type-of-link',
  FORM_0 = 'form-0',
  FORM_EMPLOYEE = 'form-employee',
  HPMS_EMPLOYEE_CARD = 'hpms-employee-card',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_FILTER = 'input-filter',
  INPUT_NR_SEQUENCE = 'input-nrSequence',
  LAYOUT_EMPLOYEES = 'layout-employees',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_3 = 'mapper-3',
  PANEL_1 = 'panel-1',
  PANEL_CONTENT_FORM_EMPLOYEE = 'panel-content-form-employee',
  PANEL_EMPLOYEES = 'panel-employees',
  PANEL_FILTER = 'panel-filter',
  PANEL_PENDENCIES = 'panel-pendencies',
  PHONE_NUMBER_0 = 'phone-number-0',
  TEXT_0 = 'text-0',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_5 = 'text-5',
  TOAST_NOTIFICATION = 'toast-notification',
  UNBOXED_TYPE_OF_LINK = 'unboxed-type-of-link',
}
export { ProviderAccreditationEmployeesAliases };
